import { render, staticRenderFns } from "./activityStudents.vue?vue&type=template&id=287dec22"
import script from "./activityStudents.vue?vue&type=script&lang=js"
export * from "./activityStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports